import { TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS, TRIGGER_CLEAR_PREPAID_TXN_DETAILS } from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const PrePaidTxnStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS:
			return {
				...state,
				...action.data,
			};

		case TRIGGER_CLEAR_PREPAID_TXN_DETAILS:
			return {};
		default:
			return state;
	}
};

export default PrePaidTxnStatusReducer;
